import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import '../static/css/sidebarPrivilages.css'
import '../../../static/css/adminlte.css'
import '../../../static/css/blue-skin.css'
import '../../../static/css/custom_bootstrap.css'
import '../../../static/css/custom.css'
import { headerDataUpdate,  buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'

//import * as Helpers from '../../../common/helpers'

const PRODUCT_LIST_TABLE = Constants.PRODUCT_LIST_TABLE
const KITS_TABLE = Constants.KITS_TABLE
const BRANDS_TABLE = Constants.BRANDS_TABLE
const PRODUCTS_STOCKS_TABLE = Constants.PRODUCTS_STOCKS_TABLE
const CITIES_TABLE = Constants.CITIES_TABLE
const CLUSTERS_TABLE = Constants.CLUSTERS_TABLE
const KITCHENS_TABLE = Constants.KITCHENS_TABLE
const STORES_TABLE = Constants.STORES_TABLE
const PRIVILEGES_TABLE = Constants.PRIVILEGES_TABLE
const EMPLOYEES_TABLE = Constants.EMPLOYEES_TABLE
const ROLES_TABLE = Constants.ROLES_TABLE
const DESIGNATIONS_TABLE = Constants.DESIGNATIONS_TABLE
const STORES_TICKETS_TABLE = Constants.STORES_TICKETS_TABLE
const REASONS_TABLE = Constants.REASONS_TABLE
const COSTCENTERS_TABLE = Constants.COSTCENTERS_TABLE
const DEPARTMENTS_TABLE = Constants.DEPARTMENTS_TABLE
const WORKLOCATIONS_TABLE = Constants.WORKLOCATIONS_TABLE
const EMPLOYEES_ATTRITION_TABLE = Constants.EMPLOYEES_ATTRITION_TABLE
const TEAMS_TABLE = Constants.TEAMS_TABLE
const ST_AGENTS_TABLE = Constants.ST_AGENTS_TABLE
const HR_TICKETS_TABLE = Constants.HR_TICKETS_TABLE
const ST_REPORTS_TABLE = Constants.ST_REPORTS_TABLE
const DEPARTMENT_TEAMS_TABLE = Constants.DEPARTMENT_TEAMS_TABLE
const EMPLOYEES_MOVEMENT_TABLE = Constants.EMPLOYEES_MOVEMENT_TABLE
const CATEGORIES_TABLE = Constants.CATEGORIES_TABLE
const MENUS_TABLE = Constants.MENUS_TABLE
const MENU_DISABLED_TICKETS_TABLE = Constants.MENU_DISABLED_TICKETS_TABLE
const KITCHEN_STAFFS_TABLE = Constants.KITCHEN_STAFFS_TABLE
const USERS_TABLE = Constants.USERS_TABLE
const EMPLOYEE_DEPUTE_TABLE = Constants.EMPLOYEE_DEPUTE_TABLE
const EMPLOYEE_REHIRE_TABLE = Constants.EMPLOYEE_REHIRE_TABLE
const EMPLOYEE_PROMOTION_TABLE = Constants.EMPLOYEE_PROMOTION_TABLE
const ATTENDANCE_TABLE = Constants.ATTENDANCE_TABLE
const ORDER_VERIFICATION_TABLE = Constants.ORDER_VERIFICATION_TABLE
const ATTENDANCE_CYCLES_TABLE = Constants.ATTENDANCE_CYCLES_TABLE
const EMPLOYEE_PAY_SCALES_TABLE = Constants.EMPLOYEE_PAY_SCALES_TABLE
const ENTITY_TYPES_TABLE = Constants.ENTITY_TYPES_TABLE
const ENTITY_STATUS_TABLE = Constants.ENTITY_STATUS_TABLE
const PLATFORMS_TABLE = Constants.PLATFORMS_TABLE
const ATTENDANCE_SUMMARY_TABLE = Constants.ATTENDANCE_SUMMARY_TABLE
const NEW_JOINEE_TABLE = Constants.NEW_JOINEE_TABLE
const ASSETS_TABLE = Constants.ASSETS_TABLE
const ASSET_TYPES_TABLE = Constants.ASSET_TYPES_TABLE
const ASSET_VENDORS_TABLE = Constants.ASSET_VENDORS_TABLE
const ASSET_LOCATIONS_TABLE = Constants.ASSET_LOCATIONS_TABLE
const EQUIPMENTS_TABLE = Constants.EQUIPMENTS_TABLE






class SideBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userPrivileges:[],
            bodyHeight:0
        }
        this.isComponentStillMounted = true
        this.dialog = null        
        
    }

    componentDidMount() {  



        if (this.props.user && this.props.user.headerTitle) {
             this.onClickSideBar(this.props.user.headerTitle);
         }

         if (this.props.user && this.props.user.roles && this.props.user.roles.length > 0) {

            let userPrivileges=[];
            let privilegesObj = this.props.user.privileges
            let pri=Object.entries(privilegesObj);

            pri.map(function(item) { 
                userPrivileges.push({"name":item[1].name,"api_access":item[1].api_access,"app_access":item[1].app_access}) 
                return true
            })

            this.setState({
                userPrivileges: userPrivileges
            });
        }
    }

    componentWillMount() {
        this.isComponentMounted = true
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user.headerTitle) {
             this.onClickSideBar(nextProps.user.headerTitle);
         }
    }


    camelize(str) {
          return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
            if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
          });
        }

    onClickSideBar(PageName){
        this.props.dispatch(headerDataUpdate(PageName))
        //this.props.dispatch(subHeaderDataUpdate())
        this.removeClickedTabClassName()
        PageName=PageName.split(" -")[0];
        if(document.querySelectorAll(".sidebar-menu ."+this.camelize(PageName)).length>0){
                document.querySelectorAll(".sidebar-menu ."+this.camelize(PageName))[0].className=
                document.querySelectorAll(".sidebar-menu ."+this.camelize(PageName))[0].className+=" nav-bar-clicked-tab"
        }
    }


    removeClickedTabClassName(){

        var elements =  document.querySelectorAll(".sidebar-menu li");
        for (var i = 0; i < elements.length; i++) {
            elements[i].className=elements[i].className.replace(" nav-bar-clicked-tab", "")
        }

    }

    updateDimensions = () => {
        this.setState({
            bodyHeight: (window.innerHeight - 65) + "px",
        })       
    }



    checkUserAccess(handle){
     
    let flagCheck=false;
     this.state.userPrivileges.map(function(item) {
        if(item.app_access===handle){
            flagCheck=true;
            }
            return true
         });

        if(!flagCheck){
            return "hidesidebar"
        }else{
            return ""
        }

    }

    render() {
        // let userRole = "default"
        // if (this.props.user && this.props.user.roles && this.props.user.roles.length > 0) {
        //     userRole = this.props.user.roles[0]
        // }
        return (
            <div className="crm-side-bar" style={{ backgroundColor: '#626262' }}>
                <Dialog ref={el => this.dialog = el}/>
                <aside className="navbar-background skin-blue main-sidebar">
                    <section className="sidebar" style={{ maxHeight: this.state.bodyHeight }}>
                        <ul className="sidebar-menu">

                            <li
                                className={"treeview "+this.camelize(PRODUCT_LIST_TABLE)+" "+this.checkUserAccess('/dashboard/products/list')}
                                ref="products_list_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(PRODUCT_LIST_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/products/list">
                                    <i className="fa fa-shopping-basket"></i>
                                    <span> Products List</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(KITS_TABLE)+" "+this.checkUserAccess('/dashboard/kits/list')}
                                ref="products_kits_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(KITS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/kits/list">
                                    <i className="fa fa-cutlery"></i>
                                    <span>Kits</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(PRODUCTS_STOCKS_TABLE)+" "+this.checkUserAccess('/dashboard/products/stocks/list')}
                                ref="products_stocks_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(PRODUCTS_STOCKS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/products/stocks/list">
                                    <i className="fa fa-server"></i>
                                    <span>Products Stocks</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(CITIES_TABLE)+" "+this.checkUserAccess('/dashboard/cities/list')}
                                ref="cities_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(CITIES_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/cities/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Cities</span></Link>
                            </li>

                            <li 
                                className={"treeview "+this.camelize(CLUSTERS_TABLE)+" "+this.checkUserAccess('/dashboard/clusters/list')}
                                ref="clusters_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(CLUSTERS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/clusters/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Clusters</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(BRANDS_TABLE)+" "+this.checkUserAccess('/dashboard/brands/list')}
                                ref="brands_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(BRANDS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/brands/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Brands</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(KITCHENS_TABLE)+" "+this.checkUserAccess('/dashboard/kitchens/list')}
                                ref="kitchens_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(KITCHENS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/kitchens/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Kitchens</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(KITCHEN_STAFFS_TABLE)+" "+this.checkUserAccess('/dashboard/kitchenStaffs/list')}
                                ref="kitchen_staffs_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(KITCHEN_STAFFS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link to="/dashboard/kitchenStaffs/list">
                                    <i className="fa fa-users"></i>
                                    <span> Kitchen Staffs</span></Link>
                            </li>


                            <li
                                className={"dropdown treeview "+this.camelize(STORES_TABLE)+" "+this.checkUserAccess('/dashboard/stores/list')}
                                ref="stores_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(STORES_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link className="dropdown-toggle" to="/dashboard/stores/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Stores</span></Link>
                            </li>

                            <li
                                className={"dropdown treeview "+this.camelize(STORES_TICKETS_TABLE)+" "+this.checkUserAccess('/dashboard/storestickets/list')}
                                ref="stores_tickets_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(STORES_TICKETS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link className="dropdown-toggle" to="/dashboard/storestickets/list">
                                    <i className="fa fa-ticket"></i>
                                    <span> Store Tickets</span></Link>
                            </li>
                            <li
                                className={"dropdown treeview "+this.camelize(ST_REPORTS_TABLE)+" "+this.checkUserAccess('/dashboard/storestickets/summary')}
                                ref="st_reports_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ST_REPORTS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link className="dropdown-toggle" to="/dashboard/storestickets/summary">
                                    <i className="fa fa-building-o"></i>
                                    <span>Store Tickets Summary</span></Link>
                            </li>


                            <li
                                className={"dropdown treeview "+this.camelize(ST_AGENTS_TABLE)+" "+this.checkUserAccess('/dashboard/storestickets/agents/list')}
                                ref="st_agents_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ST_AGENTS_TABLE)
                                    this.props.callBack()
                                }}>
                                <Link className="dropdown-toggle" to="/dashboard/storestickets/agents/list">
                                    <i className="fa fa-users"></i>
                                    <span> Store Tickets Agents</span></Link>
                            </li>




                            <li
                                className={"treeview "+this.camelize(CATEGORIES_TABLE)+" "+this.checkUserAccess('/dashboard/categories/list')}
                                ref="categories_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(CATEGORIES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/categories/list">
                                    <i className="fa fa-cutlery"></i>
                                    <span> Menu Categories</span></Link>
                            </li>
                            <li
                                className={"treeview "+this.camelize(MENUS_TABLE)+" "+this.checkUserAccess('/dashboard/menus/list')}
                                ref="menus_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(MENUS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/menus/list">
                                    <i className="fa fa-cutlery"></i>
                                    <span>Menus</span></Link>
                            </li>
                            



                               <li
                                className={"treeview "+this.camelize(MENU_DISABLED_TICKETS_TABLE)+" "+this.checkUserAccess('/dashboard/menuDisabledTickets/list')}
                                ref="menu_disabled_tickets_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(MENU_DISABLED_TICKETS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/menuDisabledTickets/list">
                                    <i className="fa fa-ticket"></i>
                                    <span> Menu Disabled Tickets</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(ASSETS_TABLE)+" "+this.checkUserAccess('/dashboard/assets/list')}
                                ref="assets_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ASSETS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/assets/list">
                                    <i className="fa fa-list"></i>
                                    <span> Assets</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(EQUIPMENTS_TABLE)+" "+this.checkUserAccess('/dashboard/equipments/list')}
                                ref="equipments_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EQUIPMENTS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/equipments/list">
                                    <i className="fa fa-list"></i>
                                    <span> Equipments</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(ASSET_TYPES_TABLE)+" "+this.checkUserAccess('/dashboard/equipmentCategory/list')}
                                ref="asset_types_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ASSET_TYPES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/equipmentCategory/list">
                                    <i className="fa fa-list"></i>
                                    <span> Equipment Categories</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(ASSET_VENDORS_TABLE)+" "+this.checkUserAccess('/dashboard/vendors/list')}
                                ref="asset_vendors_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ASSET_VENDORS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/vendors/list">
                                    <i className="fa fa-list"></i>
                                    <span> Asset Vendors</span></Link>
                            </li>


                            {/*<li
                                className={"treeview "+this.camelize(ASSET_LOCATIONS_TABLE)+" "+this.checkUserAccess('/dashboard/assetLocations/list')}
                                ref="asset_locations_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ASSET_LOCATIONS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/assetLocations/list">
                                    <i className="fa fa-list"></i>
                                    <span> Asset Locations</span></Link>
                            </li>*/}

                            <li
                                className={"treeview "+this.camelize(ORDER_VERIFICATION_TABLE)+" "+this.checkUserAccess('/dashboard/orderVerification/list')}
                                ref="order_verification_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ORDER_VERIFICATION_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/orderVerification/list">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                    <span> Order Verification</span></Link>
                            </li>


                            

                            <li
                                className={"treeview "+this.camelize(EMPLOYEES_TABLE)+" "+this.checkUserAccess('/dashboard/employees/list')}
                                ref="employees_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employees/list">
                                    <i className="fa fa-users"></i>
                                    <span> Employees</span></Link>
                            </li>



                            <li
                                className={"treeview "+this.camelize(EMPLOYEES_ATTRITION_TABLE)+" "+this.checkUserAccess('/dashboard/employeesAttrition/list')}
                                ref="employees_attrition_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEES_ATTRITION_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employeesAttrition/list">
                                    <i className="fa fa-users"></i>
                                    <span> Employees Attritions</span></Link>
                            </li>
                            <li
                                className={"treeview "+this.camelize(EMPLOYEES_MOVEMENT_TABLE)+" "+this.checkUserAccess('/dashboard/employeeMovements/list')}
                                ref="employees_movement_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEES_MOVEMENT_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employeeMovements/list">
                                    <i className="fa fa-users"></i>
                                    <span> Employees Movement</span></Link>
                            </li>
                            <li
                                className={"treeview "+this.camelize(NEW_JOINEE_TABLE)+" "+this.checkUserAccess('/dashboard/newJoinee/list')}
                                ref="newJoinee_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(NEW_JOINEE_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/newJoinee/list">
                                    <i className="fa fa-users"></i>
                                    <span> New Joinees </span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(EMPLOYEE_DEPUTE_TABLE)+" "+this.checkUserAccess('/dashboard/employeeDeputedLocations/list')}
                                ref="employees_depute_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEE_DEPUTE_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employeeDeputedLocations/list">
                                    <i className="fa fa-users"></i>
                                    <span> Employees Deputy</span></Link>
                            </li> 


                            <li
                                className={"treeview "+this.camelize(EMPLOYEE_REHIRE_TABLE)+" "+this.checkUserAccess('/dashboard/employeeRehire/list')}
                                ref="employee_rehire_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEE_REHIRE_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employeeRehire/list">
                                    <i className="fa fa-users"></i>
                                    <span> Employees Rehire</span></Link>
                            </li> 


                            <li
                                className={"treeview "+this.camelize(EMPLOYEE_PROMOTION_TABLE)+" "+this.checkUserAccess('/dashboard/employeePromotion/list')}
                                ref="employee_promotion_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEE_PROMOTION_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employeePromotion/list">
                                    <i className="fa fa-users"></i>
                                    <span> Employees Promotion</span></Link>
                            </li> 


                            <li
                                className={"treeview "+this.camelize(ATTENDANCE_TABLE)+" "+this.checkUserAccess('/dashboard/attendances/list')}
                                ref="employee_attendances_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ATTENDANCE_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/attendances/list">
                                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                                    <span> Attendance</span></Link>
                            </li> 



                            <li
                                className={"treeview "+this.camelize(ATTENDANCE_SUMMARY_TABLE)+" "+this.checkUserAccess('/dashboard/attendances/summary')}
                                ref="attendances_summary_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ATTENDANCE_SUMMARY_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/attendances/summary">
                                    <i class="fa fa-building-o" aria-hidden="true"></i>
                                    <span> Headcount Summary</span></Link>
                            </li> 



                            <li
                                className={"treeview "+this.camelize(ATTENDANCE_CYCLES_TABLE)+" "+this.checkUserAccess('/dashboard/attendanceCycles/list')}
                                ref="attendance_cycles_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ATTENDANCE_CYCLES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/attendanceCycles/list">
                                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                                    <span> Attendance Cycles</span></Link>
                            </li> 


                              <li
                                className={"treeview "+this.camelize(EMPLOYEE_PAY_SCALES_TABLE)+" "+this.checkUserAccess('/dashboard/employeePayScales/list')}
                                ref="employee_pay_scales_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(EMPLOYEE_PAY_SCALES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employeePayScales/list">
                                    <i class="fa fa-money" aria-hidden="true"></i>
                                    <span> Employee Pay Scales</span></Link>
                            </li> 







                            <li
                                className={"treeview "+this.camelize(HR_TICKETS_TABLE)+" "+this.checkUserAccess('/dashboard/hr/hrtickets/list')}
                                ref="hr_tickets_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(HR_TICKETS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/hr/hrtickets/list">
                                    <i className="fa fa-ticket"></i>
                                    <span> HR Tickets</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(USERS_TABLE)+" "+this.checkUserAccess('/dashboard/users/list')}
                                ref="users_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(USERS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/users/list">
                                    <i className="fa fa-users"></i>
                                    <span> Users</span></Link>
                            </li>



                            <li
                                className={"treeview "+this.camelize(TEAMS_TABLE)+" "+this.checkUserAccess('/dashboard/employees/teams/list')}
                                ref="teams_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(TEAMS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/employees/teams/list">
                                    <i className="fa fa-users"></i>
                                    <span>My Team</span></Link>
                            </li>

                              <li
                                className={"treeview "+this.camelize(DESIGNATIONS_TABLE)+" "+this.checkUserAccess('/dashboard/designations/list')}
                                ref="designations_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(DESIGNATIONS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/designations/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Designations</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(DEPARTMENTS_TABLE)+" "+this.checkUserAccess('/dashboard/departments/list')}
                                ref="departments_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(DEPARTMENTS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/departments/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Departments</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(DEPARTMENT_TEAMS_TABLE)+" "+this.checkUserAccess('/dashboard/department/teams/list')}
                                ref="department_teams_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(DEPARTMENT_TEAMS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/department/teams/list">
                                    <i className="fa fa-building-o"></i>
                                    <span> Department Teams</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(COSTCENTERS_TABLE)+" "+this.checkUserAccess('/dashboard/costCenters/list')}
                                ref="costCenters_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(COSTCENTERS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/costCenters/list">
                                    <i className="fa fa-building-o"></i>
                                    <span>Cost Centers</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(WORKLOCATIONS_TABLE)+" "+this.checkUserAccess('/dashboard/workLocations/list')}
                                ref="workLocations_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(WORKLOCATIONS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/workLocations/list">
                                    <i className="fa fa-building-o"></i>
                                    <span>Work Locations</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(ROLES_TABLE)+" "+this.checkUserAccess('/dashboard/roles/list')}
                                ref="roles_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ROLES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/roles/list">
                                    <i className="fa fa-tasks"></i>
                                    <span> Roles</span></Link>
                            </li>
                          

                             <li
                                className={"treeview "+this.camelize(REASONS_TABLE)+" "+this.checkUserAccess('/dashboard/reasons/list')}
                                ref="reasons_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(REASONS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/reasons/list">
                                    <i className="fa fa-tasks"></i>
                                    <span> Reasons</span></Link>
                            </li>

                             <li
                                className={"treeview "+this.camelize(PLATFORMS_TABLE)+" "+this.checkUserAccess('/dashboard/platforms/list')}
                                ref="platforms_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(PLATFORMS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/platforms/list">
                                    <i className="fa fa-tasks"></i>
                                    <span> Platforms</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(PRIVILEGES_TABLE)+" "+this.checkUserAccess('/dashboard/privileges/list')}
                                ref="privileges_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(PRIVILEGES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/privileges/list">
                                    <i className="fa fa-tasks"></i>
                                    <span> Privileges</span></Link>
                            </li>


                            <li
                                className={"treeview "+this.camelize(ENTITY_TYPES_TABLE)+" "+this.checkUserAccess('/dashboard/entityTypes/list')}
                                ref="entity_types_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ENTITY_TYPES_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/entityTypes/list">
                                    <i className="fa fa-tasks"></i>
                                    <span> Entity Types</span></Link>
                            </li>

                            <li
                                className={"treeview "+this.camelize(ENTITY_STATUS_TABLE)+" "+this.checkUserAccess('/dashboard/entityStatus/list')}
                                ref="entity_status_treeview"
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.onClickSideBar(ENTITY_STATUS_TABLE)
                                    this.props.callBack()       
                                }}>
                                <Link to="/dashboard/entityStatus/list">
                                    <i className="fa fa-tasks"></i>
                                    <span> Entity Status</span></Link>
                            </li>


                            
                        </ul>
                    </section>
                </aside>
            </div>
        );
    }
   
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(SideBar))


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/SideBar.js